export const getAnalyticsReservationList = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $restaurantId: String) {
  getAnalyticsReservationList(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, restaurantId: $restaurantId }) {
    bookingNumber
    date
    guestName
    noOfGuests
    restaurantId
  }
}
`;

export const getAnalyticsModulePermissions = `
query MyQuery($groupId:String, $hotelId: String, $brandId: String) {
  getEnabledAnalyticsModules(input: {brandId: $brandId, groupId: $groupId, hotelId: $hotelId}) {
    modules
  }
}
`;

export const getTotalReservationStats = `
query getTotalReservationStats($endDate:String!, $startDate: String!, $hotelId: String!, $restaurantId: String) {
  getTotalReservationStats(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, restaurantId: $restaurantId}) {
    totalGuestCount
    total
    dailyTotal {
      restaurants
      values {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
    }
    fnBStats {
      popularItems {
        itemName
        daysSinceLastOrdered
        count
        revenue
        formattedRevenue
      }
      totalOrders
      totalRevenue
      totalUpsellRevenue
      currencyCode
      orderTrend {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
      avgItemsOnOrder {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
      avgItemsPerOrder
      median
      busiestDayOfWeek {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }   
      busiestTimeOfDay {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
   } 
    popularRestaurants {
      count
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      name
    }
  }
}
`;

export const getAnalyticsSpaAppointmentList = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $spaId: String) {
  getAnalyticsSpaAppointmentList(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, spaId: $spaId }) {
    bookingId
    date
    noOfGuests
    spaId
    spaName
  }
}
`;

export const getAnalyticsTotalSpaAppointments = `
query getAnalyticsTotalSpaAppointments($endDate: String!, $startDate: String!, $hotelId: String!, $spaId: String) {
  getAnalyticsTotalSpaAppointments(
    input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, spaId: $spaId}
  ) {
    dailyTotal {
      spas
      values {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
    }
    total
    currencyCode
    spaStatistics {
      orderTrend {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
      busiestDayOfWeek {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
      busiestTimeOfDay {
        date
        day
        time
        orderCount
        orderAmount
        avgOrderItemsCount
      }
      popularTreatments {
        id
        name
        bookings
        revenue
        daysSinceLastOrdered
      }
    }
  }
}
`;

export const getAnalyticsMostBookedSpaTreatments = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $spaId: String, $lang: String) {
  getAnalyticsMostBookedSpaTreatments(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, spaId: $spaId, lang: $lang}) {
    mostBookedTreatments {
      bookings
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      name
      revenue
    }
    totalBookings
    totalRevenue
  }
}
`;

export const getAnalyticsTotalHKRequest = `
query getAnalyticsTotalHKRequest($endDate:String!, $startDate: String!, $hotelId: String!) {
  getAnalyticsTotalHKRequest(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate}) {
    dailyTotal {
      values
    }
    totalRequest
    failedRequest
    successfulRequest
    currencyCode
    orderTrend {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    }           
	  avgItemsOnOrder {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    }           
	  totalRevenue                                    
	  averageItemsPerRequest   
    medianItemsPerRequest                                
	  busiestDayOfWeek {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    }           
	  busiestTimeOfDay {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    }
    popularItems {
      name
      count
      daysSinceLastOrdered    
    }
    currencyCode
  }
}
`;

export const listHKAnalyticsServiceActivity = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $lang: String) {
  listHKAnalyticsServiceActivity(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, lang:$lang}) {
    averageResponseTime
    rank
    requestedCount
    serviceName
  }
}
`;

export const getHKAnalyticsServiceDetails = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $lang: String, $categoryType: String) {
  getHKAnalyticsServiceDetails(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, lang:$lang, categoryType: $categoryType}) {
    averageResponseTime
    categoryPieChartData
    topRequestedServices {
      averageResponseTime
      count
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      name
    }
    totalRequest
    totalServiceRequest
  }
}
`;

export const getTotalIRDOrderDetails = `
query getTotalIRDOrderDetails($endDate:String!, $startDate: String!, $hotelId: String!, $lang: String) {
  getTotalIRDOrderDetails(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, lang:$lang}) {
    avgDeliveryTime {
      avgTime
      differenceDirection
      difference
    }
    popularItems {
      itemName
      daysSinceLastOrdered
      count
      revenue
      formattedRevenue
    }
    orderPerDay {
      ordersPerDay
      percentage
      formattedPercentage
    }
    ordersByMenuGraph {
      menus
      values
    }
    totalOrders {
      count
      percentage
      formattedPercentage
    }
    totalOrdersGraph {
      labels
      values
    }
    totalRevenue {
      percentage
      value
      formattedValue
      currency
      formattedPercentage
    }
    orderTrend {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    }
	  avgItemsOnOrder {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    } 
	  avgItemsPerOrder                          
   	busiestDayOfWeek {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    } 
	  busiestTimeOfDay {
      date 
      day 
      time 
      orderCount   
      orderAmount 
      avgOrderItemsCount 
    } 
    medianItemsPerRequest
  }
}
`;

export const getAnalyticsCheckInStats = `
query getAnalyticsCheckInStats($endDate:String!, $startDate: String!, $hotelId: String!, $channel: String) {
  getAnalyticsCheckInStats(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, channel: $channel}) {
    channels {
      channel
      count
      percentage
      formattedCount
    }
    checkInCheckOutGraph {
      labels
      values
    }
    checkInSuccessErrorTrend {
      date
      day
      successCount
      errorCount
    }
	  keyGenerationSuccessErrorTrend {
      date
      day
      successCount
      errorCount
    }
	  eRegistrationSuccessErrorTrend {
      date
      day
      successCount
      errorCount
    }
    paymentSuccessErrorTrend {
      date
      day
      successCount
      errorCount
      }      
    totalERegistrationErrorPercentage
    totalERegistrationErrorCount
    
    totalKeyGenerationErrorPercentage   
    totalKeyGenerationErrorCount

    totalPaymentErrorPercentage
    totalPaymentErrorCount

    totalCheckInErrorCount
    totalCheckInErrorPercentage

    digitalCheckIn {
    uniqueDocumentUploads {
      formattedValue
      percentage
      value
      }
    uniqueKeyGenerations {
      formattedValue
      percentage
      value
      }
    uniqueCheckInFailures {
      formattedValue
      percentage
      value
      }
    uniqueKeyGenerationFailures {
      formattedValue
      percentage
      value
      }
    uniquePaymentFailures {
      formattedValue
      percentage
      value
      }
    totalERegistrationFailures {
      formattedValue
      percentage
      value
      }
    totalPaymentFailures {
      formattedValue
      percentage
      value
      }
    totalPaymentFailures {
      formattedValue
      percentage
      value
      }
    failedPMSPayments {
      formattedValue
      percentage
      value
      }
    successPMSPayments {
      formattedValue
      percentage
      value
      }
    checkInAdoption {
      formattedValue
      percentage
      value
      }
    checkInCompleted {
      formattedValue
      percentage
      value
      }
    documentsUploaded {
      formattedValue
      percentage
      value
      }
    eRegistrationsReceived {
      formattedValue
      percentage
      value
      }
    preCheckIns {
      formattedValue
      percentage
      value
      }
    totalCheckIns {
      formattedValue
      percentage
      value
      }
    totalKeyGeneration {
      formattedValue
      percentage
      value
      }
    totalPayments {
      formattedValue
      percentage
      value
      }
    totalPaymentsRevenue {
      formattedValue
      percentage
      value
      }
    totalKeyGenerationsFailed {
      formattedValue
      percentage
      value
      }
    reattemptedCheckIns {
      formattedValue
      percentage
      value
      }
    totalFailedCheckIns {
      formattedValue
      percentage
      value
      }
    totalRevenue {
      formattedValue
      percentage
      value
      }
    totalUpsellCount{
      formattedValue
      percentage
      value
      }
    }
    checkInTrend {
      date
      day
      successCount
      errorCount
      checkInCount
      preCheckInCount
      arrivalConversion
    }
     totalCheckOut{
      formattedValue
      percentage
      value
      }
    preArrivalEmails {
      checkInInitiated {
        formattedValue
        percentage
        value
      }
      noResponses {
        formattedValue 
        percentage
        value
      }
      totalEmailsDelivered {
        formattedValue
        percentage
        value
      }
      totalEmailsSent {
        formattedValue
        percentage
        value
      }
    }
    errorBreakDown {
      type
      date
      errorMessage
      reservationId
    }
    upsellActivityGraph
  }
}
`;

export const getAnalyticsUsageStats = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!) {
  getAnalyticsUsageStats(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate}) {
    totalHits {
      pieChartData
      total
    }
    userStats {
      androidDownloads {
        formattedValue
        value
      }
      androidNewUsers {
        formattedValue
        value
      }
      androidTotalUsers {
        formattedValue
        value
      }
      downloads {
        formattedValue
        percentage
        value
      }
      iosDownloads {
        formattedValue
        value
      }
      iosNewUsers {
        formattedValue
        value
      }
      iosTotalUsers {
        formattedValue
        value
      }
      newUsers {
        percentage
        value
        formattedValue
      }
      totalUsers {
        percentage
        value
        formattedValue
      }
      userRetention {
        percentage
        value
        formattedValue
      }
      lastMonthStats {
        dailyUserCount
        userCountByCountry {
          count
          country
          formattedCount
          percentage
        }
        formattedTotalUserCount
        totalUserCount
      }
      userCountByCountry {
        geoGraphData
        tableData {
          count
          country
          percentage
          formattedCount
          trendPercentage
        }
      }
    }
    sessionStats {
      appLoadTime {
        percentage
        value
        formattedValue
      }
      averageSessionFrequency
      averageSessionTime {
        percentage
        value
        formattedValue
      }
      userEngagement {
        percentage
        value
        formattedValue
      }
      userEngagementBySessions
    }
  }
}
`;

export const getTopIrdItems = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $categoryId: String) {
  getTopIrdItems(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, categoryId: $categoryId}) {
    totalUpsellRevenue
    categoryList
    itemList {
      count
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      itemName
      revenue
      formattedRevenue
    }
    totalItemCount
    totalItemRevenue
    totalUpsellRevenue
    formattedTotalItemRevenue
    formattedTotalUpsellRevenue
    totalUpsellCount
    upsellItemList {
      count
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      itemName
      revenue
      formattedRevenue
    }
  }
}
`;

export const getTopIrdItemsFilter = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $categoryId: String) {
  getTopIrdItems(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, categoryId: $categoryId}) {
    totalUpsellRevenue
    categoryList
    itemList {
      count
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      itemName
      revenue
      formattedRevenue
    }
    totalItemCount
    totalItemRevenue
    totalUpsellCount
    formattedTotalItemRevenue
    formattedTotalUpsellRevenue
    upsellItemList {
      count
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      itemName
      revenue
      formattedRevenue
    }
  }
}
`;

export const listItemActivity = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $isUpsell: Boolean) {
  listItemActivity(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, isUpsell:$isUpsell}) {
    itemName
    itemsAddedToCart
    itemsViewed
    purchased
    rank
    totalRevenue
  }
}
`;

export const listUpsellItemActivity = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $isUpsell: Boolean) {
  listItemActivity(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, isUpsell:$isUpsell}) {
    itemName
    itemsAddedToCart
    itemsViewed
    purchased
    rank
    totalRevenue
  }
}
`;

export const listSPAAnalyticsServiceActivity = `
query MyQuery($endDate:String!, $startDate: String!, $hotelId: String!, $spaId: String, $lang: String) {
  listSPAAnalyticsServiceActivity(input: {hotelId: $hotelId, endDate: $endDate, startDate: $startDate, spaId:$spaId, lang: $lang}) {
    bookings
    name
    rank
    revenue
  }
}
`;
